// Preview for label
(function() {

	// MODULE
	var FilePreviewer = (function() {
		var __private = {
			labelClassName: "img-file-btn",
			hasImageClass : "bg",

			listener() {
				var labels = document.getElementsByClassName(this.labelClassName);

				for (let i = 0; i < labels.length; i++) {
					const l = labels[i];

					l.addEventListener("change", __private.input);
				}
			},

			input(event) {
				event = event || window.event;

				var label = this;
				var input = event.target; 

				reader(label, input.files[0]);

				setTimeout(() => {
					if(label.style.backgroundImage != '') label.classList.add(__private.hasImageClass);
					else label.classList.remove(__private.hasImageClass);
				}, 100);
			}
		};

		return {
			init() {
				__private.listener();
			}
		};
	})();


	// RUN SCRIPT
	document.addEventListener("DOMContentLoaded", function() {
		var inputs = document.getElementsByClassName("img-file-btn");

		if(inputs.length > 0) FilePreviewer.init();
	});

})();